import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function CheckIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7698 8.20938C17.0684 8.49647 17.0777 8.97125 16.7906 9.26983L10.5406 15.7698C10.3962 15.92 10.1959 16.0033 9.98764 15.9999C9.77936 15.9965 9.58189 15.9066 9.44254 15.7517L7.19254 13.2517C6.91544 12.9438 6.9404 12.4696 7.24828 12.1925C7.55617 11.9154 8.03038 11.9404 8.30748 12.2483L10.0182 14.149L15.7094 8.23017C15.9965 7.93159 16.4713 7.92228 16.7698 8.20938Z"
        fill="currentColor"
      />
    </svg>
  );
};
